<template>
  <div>
    <div class="container">
      <TextArea
        class="child"
        :textTitle="endpointName"
        :textLinesArray="endpointDesc"
      ></TextArea>
      <EndpointCard
        class="child"
        cardTitle="ENDPOINTS"
        :endpoints="endpoints"
      />
      <TextArea
        class="child"
        :textTitle="filteringTitle"
        :textLinesArray="filteringText"
      ></TextArea>
    </div>
    <div ref="GET" class="container">
      <Attribute
        class="child"
        :attributes="attributes"
        :endpoint="responseTitle"
      />
      <ResponseCard
        class="child"
        :response="response"
        :cardTitle="responseCodeTitle"
      />
    </div>
    <div ref="GET_SECONDARY_STATUS_TEMPLATES" class="container">
      <Attribute
        class="child"
        :attributes="responseSecondaryStatusTemplatesAttributes"
        endpoint="SecondaryStatusTemplates"
      />
      <ResponseCard
        class="child"
        :response="responseSecondaryStatusTemplates"
        cardTitle="SecondaryStatusTemplates response"
      />
    </div>
    <div ref="GET_SECONDARY_STATUS_BY_ID" class="container">
      <Attribute
        class="child"
        :attributes="responseSecondaryStatusAttributes"
        endpoint="SecondaryStatus"
      />
      <ResponseCard
        class="child"
        :response="responseSecondaryStatus"
        cardTitle="SecondaryStatus response"
      />
    </div>
    <div ref="POST" class="container">
      <div class="child">
        <TextArea :textTitle="postTitle" :textLinesArray="postDesc"></TextArea>
        <div>
          <Attribute :attributes="postAttributes" endpoint="ExternalWorksheetDTO" />
          <Attribute
            :attributes="postAttributes_address"
            endpoint="AssociationAddressDTO"
          />
          <Attribute
            :attributes="postAttributes_calendarEvent"
            endpoint="CalendarEventsDTO"
          />
        </div>
      </div>
      <div class="child">
        <PostExample
          :postExample="postExample"
          cardTitle="POST /api/v4.0/worksheets"
        />
        <ResponseCard
          class="mt-5"
          :response="postResponse"
          cardTitle="RESPONSE."
        />
      </div>
    </div>
    <div ref="PATCH" class="container">
      <div class="child">
        <TextArea textTitle="Worksheets PATCH Object" :textLinesArray="patchDesc"></TextArea>
        <div>
          <Attribute :attributes="patchAttributes" endpoint="WorksheetUpdateRequestDTO" />
        </div>
      </div>
      <div class="child">
        <PostExample
          :postExample="patchExample"
          cardTitle="PATCH /api/v4.0/worksheets"
        />
        <ResponseCard
          class="mt-5"
          :response="patchResponse"
          cardTitle="RESPONSE."
        />
      </div>
    </div>
    <div ref="PATCH_SECONDARY_STATUS" class="container">
      <div class="child">
        <TextArea textTitle="SecondaryStatuses PATCH Object" :textLinesArray="patchDesc"></TextArea>
        <div>
          <Attribute :attributes="patchAttributesSecondaryStatuses" endpoint="SecondaryStatusValueUpdateRequestDTO" />
        </div>
      </div>
      <div class="child">
        <PostExample
          :postExample="patchExampleSecondaryStatuses"
          cardTitle="PATCH /api/v4.0/worksheets/secondarystatuses"
        />
        <ResponseCard
          class="mt-5"
          :response="patchResponseSecondaryStatuses"
          cardTitle="RESPONSE."
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .postCard {
    max-height: 600px;
  }

  .container {
    display: flex;
    flex-flow: row wrap;
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .child {
    min-width: 40%;
    max-width: 45%;
    flex-grow: 1;
    flex-shrink: 1;
  }

  @media screen and (max-width: 500px) {
    .container {
      flex-flow: column wrap;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  @media screen and (max-width: 500px) {
    .child {
      max-width: 380px;
      min-width: 300px;
    }
  }
</style>
<script>
import EndpointCard from "../../../components/content/EndpointCard.vue";
import Attribute from "../../../components/request/Attribute.vue";
import TextArea from "../../../components/content/TextArea.vue";
import ResponseCard from "../../../components/request/ResponseCard.vue";
import PostExample from "../../../components/request/PostExample.vue";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
    PostExample,
  },
  created() {
    this.$root.$on("scrollToEndpoint", (ref) => {
      var element = this.$refs[ref];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    });
  },
  computed: {
    postTitle() {
      return this.$t("worksheetsv4.postTitle");
    },
    endpointName() {
      return this.$t("worksheetsv4.endpointTitle");
    },
    postAttributes() {
      return this.$t("worksheetsv4.postAttributes_workSheetDTO");
    },
    postAttributes_address() {
      return this.$t("worksheetsv4.postAttributes_2_address");
    },
    postAttributes_calendarEvent() {
      return this.$t("worksheetsv4.postAttributes_3_calendarEvent");
    },
    postDesc() {
      return this.$t("worksheetsv4.postDesc");
    },
    postExample() {
      return this.$t("worksheetsv4.postExample");
    },
    postResponse() {
      return this.$t("worksheetsv4.postResponse");
    },
    filteringTitle() {
      return this.$t("worksheetsv4.filteringTitle");
    },
    filteringText() {
      return this.$t("worksheetsv4.filteringText");
    },
    responseTitle() {
      return this.$t("worksheetsv4.getTitle");
    },
    responseCodeTitle() {
      return this.$t("worksheetsv4.responseCodeTitle");
    },
    endpointDesc() {
      return this.$t("worksheetsv4.endpointDesc");
    },
    endpoints() {
      return this.$t("worksheetsv4.controllerEndpoints");
    },
    response() {
      return this.$t("worksheetsv4.getResponse");
    },
    attributes() {
      return this.$t("worksheetsv4.getAttributes");
    },
    responseSecondaryStatusTemplates() {
      return this.$t("worksheetsv4.getResponseSecondaryStatusTemplates");
    },
    responseTitleSecondaryStatusTemplates() {
      return this.$t("worksheetsv4.responseTitleSecondaryStatusTemplates");
    },
    responseSecondaryStatusTemplatesAttributes() {
      return this.$t("worksheetsv4.getResponseSecondaryStatusTemplatesAttributes");
    },
    responseSecondaryStatus() {
      return this.$t("worksheetsv4.getResponseSecondaryStatus");
    },
    responseTitleSecondaryStatus() {
      return this.$t("worksheetsv4.responseTitleSecondaryStatus");
    },
    attributesTitleSecondaryStatus() {
      return this.$t("worksheetsv4.attributesTitleSecondaryStatus");
    },
    responseSecondaryStatusAttributes() {
      return this.$t("worksheetsv4.getResponseSecondaryStatusAttributes");
    },
    patchAttributes() {
      return this.$t("worksheetsv4.patchAttributes_ExternalWorksheetUpdateRequestDTO");
    },
    patchExample() {
      return this.$t("worksheetsv4.patchExample");
    },
    patchDesc() {
      return this.$t("worksheetsv4.patchDesc");
    },
    patchResponse() {
      return this.$t("worksheetsv4.patchResponse");
    },
    patchAttributesSecondaryStatuses() {
      return this.$t("worksheetsv4.patchAttributes_SecondaryStatusValueUpdateRequestDTO");
    },
    patchExampleSecondaryStatuses() {
      return this.$t("worksheetsv4.patchExampleSecondaryStatuses");
    },
    patchResponseSecondaryStatuses() {
      return this.$t("worksheetsv4.patchResponseSecondaryStatuses");
    }
  },
};
</script>